export const DARK_THEME = {
    typography: {
        fontFamily: "htrts_regular"
    },
    palette: {
        mode: "light",
        background: {
            default: "#ECEDF6"
        },
        primary: {
            main: "#673AB7",
            light: "#673AB71A",
            dark: "#8561c5"
        },
        secondary: {
            main: "#555555",
            light: "#777777",
            dark: "#3b3b3b"
        }
    }
}